import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SECTIONS = [
  {
    title: "Who we are",
    body: "SourceWorld Automations is a UK digital agency helping local businesses build a professional online presence, generate enquiries and automate customer communication. This policy explains how we handle personal information submitted through this website, in line with the UK GDPR and the Data Protection Act 2018.",
  },
  {
    title: "What we collect",
    body: "When you complete our contact form we collect your name, business name, email address, phone number, your current website (if provided), the service you're interested in, and your message. We also collect standard technical data such as your browser type and how you reached the site.",
  },
  {
    title: "How we use your information",
    body: "We use your details only to respond to your enquiry, prepare your free business review and, where you ask us to, provide our services. We do not sell your data, share it with third parties for their marketing, or add you to marketing lists without your permission.",
  },
  {
    title: "Lawful basis",
    body: "We process your information on the basis of legitimate interest (responding to your enquiry) and, where you engage us, for the performance of a contract. The consent checkbox on our form confirms you're happy for us to contact you about your enquiry.",
  },
  {
    title: "How long we keep it",
    body: "Enquiry details are kept only as long as needed to handle your enquiry and any resulting work, after which they are securely deleted. If you become a client, we retain records as required for accounting and legal purposes.",
  },
  {
    title: "Your rights",
    body: "You can ask us at any time to access, correct or delete the personal information we hold about you, or to object to how we use it. To exercise any of these rights, contact us through the form on this website. You also have the right to complain to the Information Commissioner's Office (ICO).",
  },
  {
    title: "Cookies",
    body: "This website may use essential cookies and privacy-respecting analytics to understand how visitors use the site and to keep it secure. You can control cookies through your browser settings.",
  },
  {
    title: "Changes to this policy",
    body: "We may update this policy from time to time. The latest version will always be published on this page.",
  },
];

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy — SourceWorld Automations"
        description="How SourceWorld Automations collects, uses and protects your personal information, in line with UK GDPR."
      />
      <Navbar />
      <main className="pt-[72px]">
        <div className="section-shell py-16 sm:py-24 max-w-3xl">
          <p className="micro-label">Legal</p>
          <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-black tracking-tight text-white">Privacy Policy</h1>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.18em] text-slate-500">Last updated: July 2026</p>
          <div className="mt-10 space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="font-heading text-lg sm:text-xl font-bold text-white">{s.title}</h2>
                <p className="mt-2.5 text-sm sm:text-base leading-relaxed text-slate-400">{s.body}</p>
              </section>
            ))}
          </div>
          <Link to="/" data-testid="privacy-back-home" className="btn-ghost mt-12">
            <ArrowLeft size={15} strokeWidth={2.5} /> Back to Homepage
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
